import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ArticleDtoResponseWidgetDto, ArticleSearchRequest } from 'model/ApiGateway';
import { withLanguageRewrite } from '@/store/handleRequestLanguage';
import { apiGateway } from 'api/apiHost';

const customBaseQuery = fetchBaseQuery({
  baseUrl: `${apiGateway.proxyPath}/articles/`,
});

export const articleSearch = createApi({
  reducerPath: 'articleSearch',
  baseQuery: withLanguageRewrite(customBaseQuery),
  endpoints: (build) => ({
    articlesSearch: build.query<ArticleDtoResponseWidgetDto, ArticleSearchRequest>({
      query: (body) => ({
        url: 'Search',
        method: 'POST',
        body: body,
      }),
    }),
    getFacets: build.query({
      queryFn: async (_arg, _queryApi, _extraOptions, fetchWithBQ) => {
        const { data } = await fetchWithBQ({
          method: 'POST',
          body: _arg,
          url: 'Facets',
        });

        if (!data) return [];

        return {
          data: data?.map((filter) => ({
            label: filter.label,
            name: filter.name,
            displayName: filter.label,
            displayNameKey: '',
            options: filter.value
              .filter((option) => option.text.length !== 0)
              .map((option) => ({
                ...option,
                selected: false,
                applied: false,
                disabled: false,
                showAggregateCount: true,
                aggregateCount: option.count,
              })),
          })),
        };
      },
    }),
  }),
});

export const { useLazyArticlesSearchQuery, useLazyGetFacetsQuery } = articleSearch;
